export const GET_BASESTATIONS = 'GET_BASESTATIONS';
export const GET_COUNT_OF_USERS_CONNECTED = 'GET_COUNT_OF_USERS_CONNECTED';
export const GET_ROUTERS = 'GET_ROUTERS';
export const GET_CONNECTED_USERS = 'GET_CONNECTED_USERS';
export const GET_MONTHLY_USERS = 'GET_MONTHLY_USERS';
export const GET_ALL_CALL_STATIONS = 'GET_ALL_CALL_STATIONS';
